module.exports = __webpack_public_path__ + "img/36.6b84944f.jpg";